import getApiClient from '../plugins/api-client';

export default {
    checkSession: function(context) {
        return new Promise((resolve, reject) => {
            {
                context.commit('startLoading')
                if (context.session.user && context.session.token) {
                    resolve()
                } else {
                    reject()
                }
            }
        })
    },

    storeUserInfo: function(context) {
        const api = getApiClient(context)

        const r = (Math.random() + 1).toString(36).substring(7);
        return new Promise((resolve, reject) => {
            api.get(`/users/me?${r}`)
                .then((response) => {
                    const user = response.data['hydra:member'][0]
                    context.commit('setUserData', user)

                    if (user.roles.includes('ROLE_PROFESSIONAL')) {
                        resolve(user)
                        return
                    }

                    api.get(`/contractor/favorite_workprofiles/${user.id}`)
                        .then(favorites => {
                            context.commit('setFavoriteWorkProfiles', favorites.data.favoriteWorkProfiles['hydra:member'])

                            resolve(user)
                        })
                        .catch(error => {
                            console.log(error)
                            reject(error)
                        })
                })
                .catch((error) => {
                    console.log(error)
                    reject(error)
                })
        })
    },

    refreshToken: function(context) {
        const api = getApiClient(context)

        let session = context.state.session
        context.commit('setSessionToken', null)

        return new Promise((resolve, reject) => {
            if (session.refreshToken) {
                api.post('auth/refresh', {
                    'refresh_token': session.refreshToken
                })
                    .then((response) => {
                        let data = response.data
                        context.commit('setSessionToken', data.token)
                        context.commit('setSessionRefreshToken', data.refresh_token)
                        resolve(data)
                    })
                    .catch((error) => {
                        context.commit('unsetTokens')
                        reject(error)
                    })
            } else {
                reject('No token available')
            }
        })
    }
}
